import { getPath } from 'designer/component/action/Action'
import { setButtonUrl } from 'designer/component/action/Api'
import {
  isExternalApiUrl,
  ROUTE_API,
  ROUTE_HIS,
} from 'designer/component/action/Config'
import { getCheckValue } from 'designer/component/action/Data'
import { REPORT_CODE_PARAM } from 'designer/component/config/Report'
import objectPath from 'object-path'

export const setHistoryData = ({ action, path, formData, designContext }) => {
  const { setFormData, urlParams = {} } = designContext
  let datasourceValue = objectPath.get(designContext, `@datasource`) || {}
  path = getPath(path, action, urlParams)
  let queryString = []
  if (action.routerParams) {
    let routerParams = action.routerParams
    routerParams.forEach(({ param, paramType, key, value }) => {
      let paramValue
      if (paramType === 'input') {
        paramValue = formData[key]
      } else if (paramType === 'condition') {
        paramValue = value
      } else if (paramType === 'datasource') {
        paramValue = objectPath.get(datasourceValue, value)
      } else if (paramType === 'urlParam') {
        paramValue = objectPath.get(urlParams, value)
      }
      if (paramValue !== null && paramValue !== undefined) {
        queryString.push(`${param}=${paramValue}`)
      }
    })
  }
  let state = null
  if (action.props) {
    let propList = action.props
    propList.map((prop) => {
      if (prop.propType === 'input' && prop.key) {
        let value = formData[prop.key]
        prop.value = value
      }
      if (prop.propType === 'formData' && formData.props) {
        let value = formData.props[prop.prop]
        prop.value = value
      }
      return prop
    })
    state = propList
  }
  let historyData = {
    pathname: path,
    search: '?' + queryString.join('&'),
    state: state,
  }
  return historyData
}

const setUrl = ({
  url,
  pathParams,
  queryParams,
  datasourceValue,
  allParams,
  formData,
  searchData,
}) => {
  let queryString = []
  if (pathParams) {
    pathParams.forEach(({ param, propType, key, value, sourceKey }) => {
      let paramValue
      if (propType === 'datasource') {
        paramValue = objectPath.get(datasourceValue, `${sourceKey}.${key}`)
      } else if (propType === 'urlParam') {
        paramValue = objectPath.get(allParams, key)
      } else if (propType === 'input') {
        paramValue =
          objectPath.get(searchData, key) || objectPath.get(formData, key)
      } else {
        paramValue = value
      }
      url = url.replace(`:${param}`, paramValue)
    })
  }
  if (queryParams) {
    queryParams.forEach(({ param, propType, key, value, sourceKey }) => {
      let paramValue
      if (propType === 'datasource') {
        paramValue = objectPath.get(datasourceValue, `${sourceKey}.${key}`)
      } else if (propType === 'urlParam') {
        paramValue = objectPath.get(allParams, key)
      } else if (propType === 'input') {
        paramValue =
          objectPath.get(searchData, key) || objectPath.get(formData, key)
      } else {
        paramValue = value
      }
      paramValue = paramValue === undefined ? '' : paramValue
      queryString.push(`${param}=${paramValue}`)
    })
    if (queryString.length > 0) {
      let connect = url.indexOf('?') > -1 ? '&' : '?'
      url = url ? url + connect + queryString.join('&') : url
    }
  }
  return url
}

const hasPrintValue = (value) => {
  return value !== undefined && value !== null && value !== ''
}

const addCheckboxGroupParamKey = (keys = [], value) => {
  if (!hasPrintValue(value) || keys.includes(value)) return keys
  keys.push(value)
  return keys
}

const addCheckboxGroupParamValue = (values = [], value) => {
  if (!hasPrintValue(value) || values.includes(value)) return values
  values.push(value)
  return values
}

const getCheckboxGroupParamKeys = (paramData = {}, includeValue = false) => {
  let keys = []
  addCheckboxGroupParamKey(keys, paramData.checkboxGroupKey)
  addCheckboxGroupParamKey(keys, paramData.key)

  if (includeValue) {
    addCheckboxGroupParamKey(keys, paramData.value)
    addCheckboxGroupParamKey(keys, paramData.checkboxGroupName)
  }

  return keys
}

const findCheckboxGroup = (key, elements = []) => {
  let checkboxGroup = null
  elements.some((ui = {}) => {
    if (ui.tagname === 'checkboxGroup' && (ui.key === key || ui.name === key)) {
      checkboxGroup = ui
      return true
    }
    if (ui.elements) {
      checkboxGroup = findCheckboxGroup(key, ui.elements)
      return !!checkboxGroup
    }
    return false
  })
  return checkboxGroup
}

const findCheckboxGroupByParam = ({
  paramData,
  jsonForm,
  includeValue = false,
}) => {
  let checkboxGroup = null
  let elements = objectPath.get(jsonForm, 'uischema.elements') || []
  let checkboxGroupKeys = getCheckboxGroupParamKeys(paramData, includeValue)

  checkboxGroupKeys.some((checkboxGroupKey) => {
    checkboxGroup = findCheckboxGroup(checkboxGroupKey, elements)
    return !!checkboxGroup
  })

  return checkboxGroup
}

const findCheckbox = (key, elements = []) => {
  let checkbox = null
  elements.some((ui = {}) => {
    if (
      (ui.tagname === 'checkbox' || ui.tagname === 'checkboxInput') &&
      (ui.key === key || ui.name === key)
    ) {
      checkbox = ui
      return true
    }
    if (ui.elements) {
      checkbox = findCheckbox(key, ui.elements)
      return !!checkbox
    }
    return false
  })
  return checkbox
}

const getCheckboxGroupTextValues = ({ checkboxGroup = {}, formData = {} }) => {
  let checkboxGroupValue = objectPath.has(formData, checkboxGroup.key)
    ? objectPath.get(formData, checkboxGroup.key)
    : objectPath.get(formData, checkboxGroup.name)

  if (Array.isArray(checkboxGroupValue)) return checkboxGroupValue
  if (!hasPrintValue(checkboxGroupValue)) return []

  let joinValue = checkboxGroup.joinValue || ','
  return `${checkboxGroupValue}`.split(joinValue)
}

const getCheckedCheckboxNames = () => {
  if (typeof document === 'undefined') return []

  return Array.from(document.querySelectorAll('input[type="checkbox"]:checked'))
    .map((checkbox) => checkbox.name)
    .filter((name) => hasPrintValue(name))
}

const getCheckboxOptionReportCodeValue = ({ option = {}, checkboxValue }) => {
  const fallbackValue = () => {
    if (typeof checkboxValue === 'boolean') return option.name
    return hasPrintValue(checkboxValue) ? checkboxValue : option.name
  }

  let optionValue = objectPath.get(option, 'value')
  if (hasPrintValue(optionValue)) return optionValue

  let dataValue = objectPath.get(option, '@value')
  if (!hasPrintValue(dataValue)) return fallbackValue()
  if (typeof dataValue !== 'object') return dataValue

  let reportValue =
    objectPath.get(dataValue, REPORT_CODE_PARAM) ||
    objectPath.get(dataValue, 'code') ||
    objectPath.get(dataValue, 'value') ||
    objectPath.get(dataValue, option.name)

  if (hasPrintValue(reportValue)) return reportValue
  return fallbackValue()
}

const addReportCodeValuesFromCheckedInputs = ({
  values,
  formData,
  checkedValues = [],
}) => {
  getCheckedCheckboxNames().forEach((checkboxName) => {
    if (!objectPath.has(formData, checkboxName)) return

    let checkboxValue = objectPath.get(formData, checkboxName)
    let isChecked = checkedValues.some(
      (checkedValue) => getCheckValue(checkboxValue) === checkedValue,
    )

    if (isChecked || checkedValues.length === 0) {
      addCheckboxGroupParamValue(values, checkboxName)
    }
  })

  return values
}

const getCheckboxGroupParamValues = ({
  paramData,
  formData,
  jsonForm,
  isReportCode = false,
}) => {
  let checkboxGroup = findCheckboxGroupByParam({
    paramData,
    jsonForm,
    includeValue: isReportCode,
  })
  let options = checkboxGroup?.options || []
  let valueType = paramData.checkboxValueType || 'name'
  let textValues =
    checkboxGroup?.valueType === 'text'
      ? getCheckboxGroupTextValues({ checkboxGroup, formData })
      : []
  let values = []
  let checkedValues = []

  options.forEach((option = {}) => {
    let checkedValue = objectPath.has(option, 'valueChecked')
      ? getCheckValue(option.valueChecked)
      : true
    addCheckboxGroupParamValue(checkedValues, checkedValue)

    let checkboxValue = objectPath.has(formData, option.key)
      ? objectPath.get(formData, option.key)
      : objectPath.get(formData, option.name)
    let isChecked = getCheckValue(checkboxValue) === checkedValue

    if (!isChecked && checkboxGroup?.valueType === 'text') {
      isChecked = textValues.includes(option.name)
    }

    if (isChecked) {
      addCheckboxGroupParamValue(
        values,
        valueType === 'value' && isReportCode
          ? getCheckboxOptionReportCodeValue({ option, checkboxValue })
          : valueType === 'value'
          ? checkboxValue
          : option.name,
      )
    }
  })

  if (isReportCode) {
    addReportCodeValuesFromCheckedInputs({ values, formData, checkedValues })
  }

  return values
}

const getCheckboxParamValues = ({ paramData, formData, jsonForm }) => {
  let checkboxKey = paramData.checkboxKey || paramData.key
  let checkbox = findCheckbox(
    checkboxKey,
    objectPath.get(jsonForm, 'uischema.elements') || [],
  )
  if (!checkbox) return []

  let checkedValue = objectPath.has(checkbox, 'valueChecked')
    ? getCheckValue(checkbox.valueChecked)
    : true
  let checkboxValue = objectPath.has(formData, checkbox.key)
    ? objectPath.get(formData, checkbox.key)
    : objectPath.get(formData, checkbox.name)

  if (getCheckValue(checkboxValue) === checkedValue) {
    return [paramData.value || paramData.test || '']
  }
  return []
}

const isCheckboxGroupParam = ({ paramData, jsonForm }) => {
  return (
    paramData.propType === 'checkboxGroup' ||
    !!findCheckboxGroupByParam({ paramData, jsonForm })
  )
}

const isCheckboxParam = ({ paramData }) => {
  return paramData.propType === 'checkbox'
}

const isPrintConditionParam = ({ paramData, jsonForm }) => {
  return (
    isCheckboxGroupParam({ paramData, jsonForm }) ||
    isCheckboxParam({ paramData })
  )
}

const isReportCodeCheckboxGroupParam = ({ paramData, jsonForm }) => {
  return (
    paramData.param === REPORT_CODE_PARAM &&
    (paramData.propType === 'checkboxGroup' ||
      !!findCheckboxGroupByParam({
        paramData,
        jsonForm,
        includeValue: true,
      }))
  )
}

const getPrintConditionParamValues = ({ paramData, formData, jsonForm }) => {
  if (isCheckboxGroupParam({ paramData, jsonForm })) {
    return getCheckboxGroupParamValues({ paramData, formData, jsonForm })
  }
  if (isCheckboxParam({ paramData })) {
    return getCheckboxParamValues({ paramData, formData, jsonForm })
  }
  return []
}

const getPrintParamValue = ({ paramData, data, checkboxParamValue }) => {
  let { datasourceValue, allParams, formData, searchData } = data
  let { propType, key, value, sourceKey } = paramData
  let paramValue

  if (
    isPrintConditionParam({
      paramData,
      jsonForm: data.designContext?.jsonForm,
    })
  ) {
    return checkboxParamValue
  }
  if (propType === 'datasource') {
    paramValue = objectPath.get(datasourceValue, `${sourceKey}.${key}`)
  } else if (propType === 'urlParam') {
    paramValue = objectPath.get(allParams, key)
  } else if (propType === 'input') {
    paramValue =
      objectPath.get(searchData, key) || objectPath.get(formData, key)
  } else {
    paramValue = value
  }
  return paramValue === undefined ? '' : paramValue
}

const setPrintUrls = ({ url, pathParams, queryParams, data }) => {
  let { formData, designContext } = data
  let jsonForm = designContext?.jsonForm
  let allPrintParams = [...(pathParams || []), ...(queryParams || [])]
  let reportCodeCheckboxParam = jsonForm
    ? allPrintParams.find((paramData) =>
        isReportCodeCheckboxGroupParam({ paramData, jsonForm }),
      )
    : null
  let checkboxParam = reportCodeCheckboxParam || (jsonForm
    ? allPrintParams.find((paramData) =>
        isPrintConditionParam({ paramData, jsonForm }),
      )
    : null)
  let checkboxParamValues = checkboxParam
    ? reportCodeCheckboxParam
      ? getCheckboxGroupParamValues({
          paramData: checkboxParam,
          formData,
          jsonForm,
          isReportCode: true,
        })
      : getPrintConditionParamValues({
          paramData: checkboxParam,
          formData,
          jsonForm,
        })
    : []

  if (checkboxParam && checkboxParamValues.length === 0) {
    return []
  }

  let printValues = checkboxParam ? checkboxParamValues : [null]
  return printValues.map((checkboxParamValue) => {
    let printUrl = url
    let queryString = []

    if (pathParams) {
      pathParams.forEach((paramData) => {
        let paramValue = getPrintParamValue({
          paramData,
          data,
          checkboxParamValue,
        })
        printUrl = printUrl.replace(`:${paramData.param}`, paramValue)
      })
    }
    if (queryParams) {
      queryParams.forEach((paramData) => {
        let paramValue = getPrintParamValue({
          paramData,
          data,
          checkboxParamValue,
        })
        queryString.push(`${paramData.param}=${paramValue}`)
      })
      if (queryString.length > 0) {
        let connect = printUrl.indexOf('?') > -1 ? '&' : '?'
        printUrl = printUrl
          ? printUrl + connect + queryString.join('&')
          : printUrl
      }
    }
    return printUrl
  })
}

export const goToForm = ({ action, data, designContext, routerDom }) => {
  let { formData } = data
  let { history } = routerDom
  let { isUiChanged, setIsUiChanged, setFormData } = designContext

  const { jsonForm } = designContext
  if (!action.formCode) return
  let path = `/display/form/${action.formCode}`
  let historyData = setHistoryData({
    action,
    path,
    designContext,
    formData,
  })
  if (action.props) {
    let pageCode = objectPath.set(jsonForm, 'props.system.props.pageCode.value')
    if (pageCode) {
      let propList = historyData.state || []
      propList.push({
        prop: 'pageCode',
        propType: 'system',
        value: pageCode,
      })
      historyData.state = propList
    }
  }
  if (action?.openNewTab) {
    let path = historyData.pathname + historyData.search
    window.open(ROUTE_HIS + path, '_blank')
  } else {
    setFormData({})
    history.push(historyData)
  }
  objectPath.del(isUiChanged, 'renderPage')
  objectPath.del(isUiChanged, 'triggerModal')
  objectPath.del(isUiChanged, 'modal')
  setIsUiChanged(isUiChanged)
  return { status: 200 }
}

export const goToPage = ({ action, data, designContext, routerDom }) => {
  let { formData } = data
  let { location, history } = routerDom
  let { isUiChanged, setIsUiChanged, setFormData } = designContext

  let state = location.state || []
  let formCode = action.formCode
  let pageProp = state.find(
    (item) => item.prop === 'pageCode' && item.propType === 'system',
  )
  if (action.sourceType === 'pageCode') {
    formCode = pageProp?.value || ''
  }
  if (!formCode) return
  let path = `/display/page/${formCode}`
  let historyData = setHistoryData({
    action,
    path,
    designContext,
    formData,
  })
  if (action?.openNewTab) {
    let path = historyData.pathname + historyData.search
    window.open(ROUTE_HIS + path, '_blank')
  } else {
    setFormData({})
    history.push(historyData)
  }
  objectPath.del(isUiChanged, 'renderPage')
  objectPath.del(isUiChanged, 'triggerModal')
  objectPath.del(isUiChanged, 'modal')
  setIsUiChanged(isUiChanged)
  return { status: 200 }
}

export const goToUrl = ({ action, data }) => {
  let { url = '', linkType = '', pagePath = '', openNewTab = false } = action
  if (linkType === 'internal') {
    url = pagePath
  } else if (linkType === 'samePath') {
    const hashPath = window.location.hash.replace(/^#/, '')
    url = `${hashPath}`
  } else if (linkType === 'api') {
    let { apiType, service = '', endpoint = '', api = '' } = action
    url = apiType === 'internal' ? service + endpoint : api
  }
  url = setButtonUrl(url, action, data)
  let target = openNewTab ? '_blank' : '_self'

  if (linkType === 'api') {
    if (url.startsWith('/')) {
      window.open(ROUTE_API + url, target)
    } else {
      window.open(`${ROUTE_API}/` + url, target)
    }
  } else if (isExternalApiUrl(linkType, url)) {
    window.open(url, target)
  } else if (url.startsWith('http')) {
    window.open(url, target)
  } else if (url.startsWith('/')) {
    window.open(ROUTE_HIS + url, target)
  } else {
    window.open(`${ROUTE_HIS}/` + url, target)
  }
  return { status: 200 }
}

export const print = ({ action, data }) => {
  let url = objectPath.get(action, 'print.url') || ''
  let pathParams = objectPath.get(action, 'print.pathParams')
  let queryParams = objectPath.get(action, 'print.queryParams')
  let urls = setPrintUrls({
    url,
    pathParams,
    queryParams,
    data,
  })
  let target = '_blank'
  urls.forEach((url) => {
    if (url.startsWith('http')) {
      window.open(url, target, 'noopener,noreferrer')
    } else if (url.startsWith('/')) {
      window.open(ROUTE_HIS + url, target, 'noopener,noreferrer')
    } else {
      window.open(`${ROUTE_HIS}/` + url, target, 'noopener,noreferrer')
    }
  })
  return { status: 200 }
}

export const backToReport = ({ designContext }) => {
  const { setDisplayMode } = designContext
  setDisplayMode('report')
}
